'use client'

import { Suspense } from 'react'
import {
  SidebarMenuSubItem,
  SidebarMenuSubButton,
  Skeleton,
  cn,
} from '@anytimefitness/pb-react-ui'
import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'

interface SidebarLinkProps {
  title: string
  url: string
}

export default function SidebarLink(props: SidebarLinkProps) {
  return (
    <Suspense fallback={<Skeleton className="h-[28px] w-full opacity-65" />}>
      <SidebarLinkInternal {...props} />
    </Suspense>
  )
}

function SidebarLinkInternal({ title, url }: SidebarLinkProps) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const isActive = pathname.includes(url)

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton
        asChild
        className={cn(
          isActive &&
            '-ml-[2px] w-full font-bold not-hover:rounded-l-none not-hover:border-l-2 not-hover:border-l-primary'
        )}
      >
        <Link
          href={`${url}${searchParams.size ? `?${searchParams.toString()}` : ''}`}
        >
          {title}
        </Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  )
}
